import { render, staticRenderFns } from "./edit-admin.vue?vue&type=template&id=3986b94b&scoped=true"
import script from "./edit-admin.vue?vue&type=script&lang=js"
export * from "./edit-admin.vue?vue&type=script&lang=js"
import style0 from "./edit-admin.vue?vue&type=style&index=0&id=3986b94b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3986b94b",
  null
  
)

export default component.exports